import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=6fd19668"
import script from "./CategoryEditor.vue?vue&type=script&lang=js"
export * from "./CategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports